import { LegalPageLayout, LegalSection } from '../components/LegalPageLayout';
import { LEGAL_SERVICE } from '../legal.constants';

export function TermsOfServicePage() {
  return (
    <LegalPageLayout title="Conditions d’utilisation">
      <LegalSection title="Objet">
        <p>
          Ces conditions encadrent l&apos;accès à l&apos;application
          Innov&apos;Paie et son utilisation. Le service comprend, selon les
          modules ouverts au client, des outils d&apos;automatisation OpenPaye,
          de gestion documentaire, de paie, de ressources humaines et de BDESE.
        </p>
      </LegalSection>

      <LegalSection title="Accès au service">
        <p>
          L&apos;accès repose sur un compte personnel ou une invitation et sur
          les droits attribués à chaque rôle. L&apos;utilisateur ne doit pas
          partager ses moyens d&apos;authentification ni tenter d&apos;accéder à
          un dossier qui ne lui est pas ouvert.
        </p>
        <p>
          Les modules, tarifs, durées d&apos;engagement et conditions de
          résiliation applicables sont ceux du contrat ou de l&apos;offre
          acceptée par le client. Les présentes conditions ne remplacent pas ces
          clauses commerciales.
        </p>
      </LegalSection>

      <LegalSection title="Données et responsabilités de l’utilisateur">
        <p>
          L&apos;utilisateur vérifie l&apos;exactitude des données et des
          paramètres qu&apos;il saisit ou valide. Lorsqu&apos;il agit pour un
          employeur, il s&apos;assure qu&apos;il dispose des habilitations
          nécessaires et respecte les obligations de paie, de droit du travail
          et de protection des données applicables.
        </p>
        <p>
          Une automatisation, un calcul ou un export reste soumis aux contrôles
          professionnels adaptés avant son utilisation dans une paie, une
          déclaration ou une information remise à un tiers.
        </p>
      </LegalSection>

      <LegalSection title="Disponibilité et assistance">
        <p>
          Des interruptions peuvent intervenir pour la maintenance, la sécurité
          ou en raison d&apos;un service tiers tel qu&apos;OpenPaye, un
          fournisseur de messagerie ou un réseau. Les engagements de
          disponibilité, de support et de reprise opposables au client figurent
          dans son contrat lorsqu&apos;ils ont été convenus.
        </p>
      </LegalSection>

      <LegalSection title="Propriété et données du client">
        <p>
          Le client conserve les droits et responsabilités attachés aux données
          de ses entreprises, salariés et dossiers. L&apos;accès d&apos;un
          cabinet ou d&apos;un autre intervenant dépend de la relation de
          service et des habilitations en vigueur ; il ne transfère pas la
          propriété des données.
        </p>
        <p>
          Le logiciel, l&apos;interface, les textes et les éléments de marque
          restent protégés par les droits de leurs titulaires. Aucun droit de
          reproduction ou de redistribution n&apos;est accordé au-delà de
          l&apos;usage du service.
        </p>
      </LegalSection>

      <LegalSection title="Données personnelles">
        <p>
          Les traitements de données personnelles sont décrits dans la politique
          de confidentialité. Pour les données RH et de paie confiées par un
          employeur, l&apos;éditeur du service agit selon les instructions du
          client et les clauses de sous-traitance convenues.
        </p>
      </LegalSection>

      <LegalSection title="Suspension et fin d’accès">
        <p>
          Un accès peut être suspendu pour protéger le service, empêcher un
          usage non autorisé ou appliquer le contrat. Les conditions de
          fermeture, de restitution et de conservation des données sont celles
          du contrat et des obligations légales applicables ; aucune suppression
          automatique uniforme n&apos;est promise par cette page.
        </p>
      </LegalSection>

      <LegalSection title="Éditeur, contact et droit applicable">
        <p>
          Innov&apos;Paie est édité par {LEGAL_SERVICE.publisher}, SAS au
          capital de {LEGAL_SERVICE.shareCapital}, immatriculée sous le numéro{' '}
          {LEGAL_SERVICE.siren}. Contact du service :{' '}
          <a
            href={`mailto:${LEGAL_SERVICE.contactEmail}`}
            className="font-medium underline decoration-neutral-300 underline-offset-4 hover:text-neutral-950"
          >
            {LEGAL_SERVICE.contactEmail}
          </a>
          .
        </p>
        <p>
          Le droit français s&apos;applique. Les modalités de règlement amiable
          et la juridiction compétente sont déterminées par le contrat et les
          règles impératives applicables à la relation concernée.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
